import React from 'react';

interface SettingsToggleWithInputProps {
  label: string;
  description?: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  value: number;
  onValueChange: (value: number) => void;
  unit: string;
  prefix?: string;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const SettingsToggleWithInput: React.FC<SettingsToggleWithInputProps> = ({
  label,
  description,
  checked,
  onToggle,
  value,
  onValueChange,
  unit,
  prefix = 'Через',
  min = 1,
  max = 365,
  disabled = false,
}) => {
  return (
    <div className="flex items-center justify-between py-4 border-b border-gray-100 last:border-b-0">
      <div className="flex-1 min-w-0 pr-4">
        <p className="text-sm font-medium text-[#2d2c2c]">{label}</p>
        {description && (
          <p className="text-sm text-gray-400 mt-0.5">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <span className="text-sm text-gray-500">{prefix}</span>
        <input
          type="number"
          value={value}
          min={min}
          max={max}
          onChange={(e) => {
            const v = parseInt(e.target.value, 10);
            if (!isNaN(v) && v >= min && v <= max) onValueChange(v);
          }}
          disabled={disabled || !checked}
          className="w-14 h-8 px-2 text-center text-sm border border-gray-200 rounded-lg
            focus:outline-none focus:border-[#e3282a]/50
            disabled:opacity-50 disabled:bg-gray-50"
        />
        <span className="text-sm text-gray-500">{unit}</span>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => onToggle(!checked)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            focus:outline-none focus:ring-2 focus:ring-[#e3282a]/30
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            ${checked ? 'bg-[#e3282a]' : 'bg-gray-300'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 rounded-full bg-white shadow-sm transition-transform
              ${checked ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>
    </div>
  );
};

export default SettingsToggleWithInput;
